import { registerBlockType } from '@wordpress/blocks';
import attributeVisibility from '@components/visibility/attributes.json';
import attributeClassDropDown from '@components/class-dropdown/attributes.json';
import { getBlockLabelByName } from '@helpers/utils';
import LinkControls from '@components/link/attributes.json';

import './style.scss';

import json from './block.json';
import edit from './edit';
import linkIcon from './icon';
import save from './save';

const { name, ...settings } = json;

const attributes = {
  ...settings.attributes,
  ...attributeVisibility,
  ...attributeClassDropDown,
  ...LinkControls,
};
registerBlockType(name, {
  ...settings,
  icon: linkIcon,
  attributes,
  edit,
  save,
  __experimentalLabel: (attributes) =>
    getBlockLabelByName(attributes, settings.title),
});
